<script setup lang="ts">
interface Props {
  content: string
}

defineProps<Props>()

const { tableContainer, showFade } = useTableOverflowFade()
</script>

<template>
  <div class="table-wrapper">
    <div ref="tableContainer" class="table-container" v-html="content" />
    <div v-if="showFade" class="fade-overlay" />
  </div>
</template>

<style scoped lang="scss">
.table-wrapper {
  position: relative;
}

.table-container {
  overflow-x: auto;
}

.fade-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 80px;
  background: linear-gradient(to left, white 0%, transparent 100%);
  pointer-events: none;
  z-index: 1;
}
</style>
